let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bNi98")).then(() => parcelRequire('7CmWE'));